export enum PropertyOccupancy {
  OWN = 'PROPRIA',
  RENTED = 'CEDIDA',
  LEASED = 'ALUGADA',
  OCCUPATED = 'OCUPADA'
}
